import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
} from '@angular/core';
import { OverviewComponentConfig } from '@products/overview/overview-component.config';
import { Subscription } from 'rxjs';
import { Logger } from '@utils/logger';
import {
  BaseProductDetailComponent,
  ModalId,
} from '@products/base-product-detail.component';
import { Page, Component as BrComponent } from '@bloomreach/spa-sdk';
import { SimpleModalConfig, ModalService } from '@frk/eds-components';
import {
  FundManagementData,
  FundManagementState,
  ProductDetailConfiguration,
} from '@types';
import { FundManagementService } from '../services/fund-management.service';
import { InvestmentTeam } from '@products/models/investment-team';
import { TranslateService } from '@shared/translate/translate.service';
const logger = Logger.getLogger('FundManagementComponent');

@Component({
  selector: 'ft-fund-management',
  templateUrl: './fund-management.component.html',
  styleUrls: ['./fund-management.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FundManagementComponent
  extends BaseProductDetailComponent
  implements OnDestroy {
  dataSubscription: Subscription;
  fundManagementInfo: FundManagementData;
  investmentManagerInfo: InvestmentTeam;
  ModalId = ModalId;
  showLinkToBios: boolean;
  hasYearsOfExperience: boolean;
  yearsOfExperienceLabel: string;
  constructor(
    private fundManagementService: FundManagementService,
    private changeDetector: ChangeDetectorRef,
    private modalService: ModalService,
    protected translateService: TranslateService
  ) {
    super();
  }

  populate(
    componentConfig: OverviewComponentConfig,
    brConfig: ProductDetailConfiguration,
    component: BrComponent,
    page: Page
  ) {
    this.initialize(brConfig, component, page);
    logger.debug(page, this.page);
    if (this.brConfig.fundId) {
      this.fundManagementService.setConfigurationName(
        componentConfig.configurationName
      );
      this.dataSubscription = this.fundManagementService.fundManagementState.subscribe(
        (newState: FundManagementState) => this.mapState(newState)
      );
      this.fundManagementService.populate(brConfig);
    }
  }
  /*
   * handling the href on eds-avatar
   */
  clickAvatar(event) {
    event.preventDefault();
  }

  openFullProfile(investmentManager: InvestmentTeam) {
    this.investmentManagerInfo = investmentManager;
    const config: SimpleModalConfig = {
      modalId: ModalId.Profile_Modal,
      type: 'simple',
      eventName: 'lightbox_display',
      eventAction: 'Click',
      eventLabel: this.getManagerTitle(investmentManager),
    };
    this.modalService.open(ModalId.Profile_Modal, config);
  }

  /**
   * Called when state changes.
   * @param fundManagementState the new state returned by fund manager service
   */
  mapState(fundManagementState: FundManagementState) {
    this.showLinkToBios = fundManagementState.data?.showLinkToBios; // NGC-12770: update visibility condition for fund manager bio link.
    this.yearsOfExperienceLabel = this.translateService.instant(
      'products.years-of-experience'
    );
    this.hasYearsOfExperience = fundManagementState.data?.showYearsOfExperience;
    this.fundManagementInfo = fundManagementState.data;
    this.changeDetector.detectChanges();
  }

  /***
   * Fetch manager title accordingly.
   * @paraminvestmentManager investment team object
   */

  getManagerTitle(investmentManager: InvestmentTeam): string {
    return `${
      investmentManager.managerName
    }${this.fundManagementService.getManagerTitleSuffix(investmentManager)}`;
  }

  ngOnDestroy() {
    // clean up subscription to avoid memory leaks
    this.dataSubscription?.unsubscribe();
  }
}
